export default __webpack_public_path__ + "static/media/cancel-24px.c1f77fb7.svg";